export default function Privacy() {
  return (
    <div className="min-h-screen bg-obsidian text-white font-body max-w-3xl mx-auto px-6 py-12">
      <h1 className="font-heading text-3xl font-black uppercase tracking-tight mb-2">Política de Privacidade</h1>
      <p className="text-txt-secondary text-sm mb-8">Última atualização: Maio 2026</p>

      <section className="space-y-6 text-sm text-txt-secondary leading-relaxed">
        <div>
          <h2 className="text-white font-bold text-base mb-2">1. Dados que Recolhemos</h2>
          <p>Recolhemos: endereço de email e nome (no registo); dados de utilização e preferências; informações de pagamento processadas pela Paddle (não armazenamos dados de cartão).</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">2. Como Usamos os Dados</h2>
          <p>Usamos os seus dados para: fornecer e melhorar o serviço; processar pagamentos; enviar comunicações sobre a sua conta; personalizar a experiência.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">3. Partilha de Dados</h2>
          <p>Não vendemos os seus dados. Partilhamos apenas com: Paddle (processamento de pagamentos); Google Analytics (análise anónima de uso); serviços essenciais de infraestrutura.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">4. Cookies</h2>
          <p>Utilizamos cookies essenciais para autenticação e cookies analíticos do Google. Pode gerir as suas preferências de cookies nas definições do browser.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">5. Os Seus Direitos (RGPD)</h2>
          <p>Tem direito a: aceder aos seus dados; corrigir dados incorretos; solicitar a eliminação da conta; exportar os seus dados; opor-se ao processamento. Para exercer estes direitos, contacte: <span className="text-volt">formulário de contacto no site</span></p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">6. Segurança</h2>
          <p>Utilizamos encriptação SSL, autenticação segura e armazenamento seguro em MongoDB Atlas para proteger os seus dados.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">7. Retenção de Dados</h2>
          <p>Mantemos os seus dados enquanto a conta estiver ativa. Após cancelamento, os dados são eliminados após 30 dias.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">8. Contacto</h2>
          <p>Para questões de privacidade: <span className="text-volt">formulário de contacto no site</span></p>
        </div>
      </section>
    </div>
  );
}
